import React from "react";
import Image from "next/image";
import { parseHtml } from "@/utils/common";
const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

interface LeaderNote {
  block: {
    title: string;
    description: string;
    image: {
      data: {
        attributes: {
          url: string;
        };
      };
    };
  };
}

const LeaderNote: React.FC<LeaderNote> = ({ block }) => {
  const imageUrl = block?.image?.data?.attributes?.url
    ? `${baseUrl}${block?.image?.data?.attributes?.url}`
    : "/images/leadership/banner-1.png"; // const buttonHref = block?.button?.href;
  return (
    <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10">
      <div className="container">
        <Image
          src={imageUrl}
          alt="leadership pillars next"
          className=" h-auto w-full object-cover mx-auto"
          width={1230}
          height={530}
        />
        <div>
          <div className="bg-[#B0D9F7] p-[10px_30px_0px_30px] max-w-[552px] mx-auto mt-[40px] mb-[28px]">
            <h5 className=" text-center text-[22px] leading-[30.2px] md:text-[26px] md:leading-[34.6px] lg:text-[28px] lg:leading-[30.6px] xl:text-[32px] xl:leading-[41.6px] font-semibold text-primary-text">
              {block?.title ? (
                parseHtml(
                  block?.title.replace(
                    "<span>",
                    "<span class='text-[#0086E6]'>"
                  )
                )
              ) : (
                <>
                  Founder
                  <span className="text-[#0086E6]"> Priyank Patel’s </span>Note
                </>
              )}
            </h5>
          </div>

          <h3 className="text-center text-heading-4 text-primary-text font-semibold">
            {block?.description ?? ""}
          </h3>
        </div>
      </div>
    </section>
  );
};

export default LeaderNote;
